/* サービス区分 */
export default {
    // 国内宿泊
    DOMESTIC_STAY: "A10",
    // 海外宿泊
    OVERSEAS_STAY:  "A15",
    // 公共の宿
    PUBLIC_ACCOMODATION:  "A20",
    // 全国の宿
    NATIONAL_ACCOMODATION:  "A25",
    // ベビーシッター/託児所
    BABYSITTING:  "B10",
    // 介護
    NURSING_CARE:  "B15",
    // グルメ
    GOURMET:  "B35",
    // その他
    OTHER:  "B40",
    // 興行チケット
    ENTERTAINMENT:  "B45",
    // お祝い
    CELEBRATION:  "B50",
    // ツアー
    TOURS:  "B55",
    // ベネ通販
    MAIL_ORDER:  "C10",
    // インセンティブポイント
    INCENTIVE_POINT:  "C15",
    // 接待ステーション
    RECEPTION_STATION:  "D15",
    // グルメクーポン
    GOURMET_COUPON:  "D20"
}